export enum EnvironmentType {
  Dev = 0,
  SIT = 1,
  UAT = 2,
  Staging = 3,
  Production = 4,
}

export enum ApplipcationStoreType {
  Peak = 0,
  NewPeak = 1,
  Payroll = 2,
  Board = 3,
}

export enum LoadingStatusType {
  None = 0,
  Loading = 1,
  Success = 2,
  Fail = 3,
}

export enum Locales {
  EN = "en",
  TH = "th",
}
export enum LanguageType {
  Th = 1,
  En = 2,
}

export enum SourceTypeProject {
  PeakMini = 0,
  PeakExperience = 1,
  PeakApi = 2,
  PeakTax = 3,
  LineConnect = 4,
  PeakDocument = 5,
}

export enum MerchantType {
  None = 0,
  LimitedLiabilityPartnership = 1,
  CompanyLimited = 2,
  PublicCompanyLimited = 3,
  Shop = 4,
  OrdinaryPerson = 5,
  BodyOfPersons = 6, //คณะบุคคล
  Others = 7,
  OrdinaryPartnership = 8, //ห้างหุ้นส่วนสามัญ
  Foundation = 9, //มูลนิธิ
  Association = 10, //สมาคม
  JointVenture = 11,
}

export enum TransactionType {
  None = 0,
  Quotation = 1,
  Invoice = 2,
  Receipt = 3,
  TaxInvoice = 4,
  CreditNote = 5,
  BillingNote = 6,
  DebitNote = 7,
  PP30 = 8,
  Pnd53 = 9,
  Pnd3 = 10,
  DailyJournal = 11,
  WithholdingTax = 12,
  Payroll = 13,
  TaxPP30 = 14,
  TaxPND53 = 15,
  TaxPND3 = 16,
  Pnd1 = 17,
  Pnd2 = 18,
}

export enum DocumentType {
  None = 0,
  Quotation = 1,
  Invoice = 2,
  Receipt = 3,
  TaxInvoice = 4,
  CreditNote = 5,
  BillingNote = 6,
  DebitNote = 7,
  PP30 = 8,
  Pnd53 = 9,
  Pnd3 = 10,
  Dailyjournal = 11,
  WithholdingTax = 12,
  Payroll = 13,
  TaxPP30 = 14,
  TaxPND53 = 15,
  TaxPND3 = 16,
  Pnd1 = 17,
  Pnd2 = 18,
  Envelope = 19,
  ExecutiveSummary = 20,
  Customize = 21,
}

export enum FinanceType {
  None = 0,
  InFlow = 1,
  OutFlow = 2,
}

export enum HeaderOptionType {
  Original,
  Copy,
  OriginalAndCopy,
}

export enum HeaderOptionName {
  None,
}

export enum JournalHeaderOptionName {
  MainJournalHeader = 0,
  CustomizeHeader = 1,
  SalesPaymentVoucherHeader = 2,
  RecordVoucherHeader = 3,
}

export enum DateOptionType {
  None,
  DateBEType1,
  DateADType1,
  DateBEType2,
  DateADType2,
}

export enum OrdinaryPersonPrefixType {
  None = 0,
  Sir = 1,
  Mr = 2,
  Mrs = 3,
  Ms = 4,
  Other = 5,
}

export enum TaxStatusType {
  ExcludeTax = 0,
  IncludeTax = 1,
  NonTax = 2,
}

export enum QuotationStatus {
  None = 0,
  Voided = 1,
  Draft = 2,
  AwaitApproval = 3,
  AwaitResponse = 4,
  Expired = 5,
  ApprovedOrAccepted = 6,
}

export enum InvoiceStatus {
  None = 0,
  Voided = 1,
  Draft = 2,
  AwaitApproval = 3,
  Outstanding = 4,
  Overdue = 5,
  PaidOrAwaitReceipt = 6,
  GotReceipt = 7,
}

export enum ReceiptStatus {
  None = 0,
  Voided = 1,
  Draft = 2,
  AwaitApproval = 3,
  Approved = 4,
}

export enum TaxInvoiceStatus {
  None = 0,
  Voided = 1,
  Draft = 2,
  AwaitApproval = 3,
  Approved = 4,
}

export enum CreditNoteStatus {
  None = 0,
  Voided = 1,
  Draft = 2,
  Approved = 3,
}

export enum BillingNoteStatus {
  None = 0,
  Voided = 1,
  Draft = 2,
  AwaitApproval = 3,
  Outstanding = 4,
  Overdue = 5,
  PaidOrAwaitReceipt = 6,
}

export enum CurrencyRatio {
  None = 0,
  Normal = 1,
  Ten = 10,
  OneHundred = 100,
  OneThousand = 1000,
}

export enum CurrencyCode {
  THB = 0,
  USD = 1,
  GBP = 2,
  EUR = 3,
  JPY = 4,
  HKD = 5,
  MYR = 6,
  SGD = 7,
  BND = 8,
  PHP = 9,
  IDR = 10,
  INR = 11,
  CHF = 12,
  AUD = 13,
  NZD = 14,
  CAD = 15,
  SEK = 16,
  DKK = 17,
  NOK = 18,
  CNY = 19,
  MXN = 20,
  ZAR = 21,
  KRW = 22,
  TWD = 23,
  KWD = 24,
  SAR = 25,
  AED = 26,
  MMK = 27,
  BDT = 28,
  CZK = 29,
  KHR = 30,
  KES = 31,
  LAK = 32,
  RUB = 33,
  VND = 34,
  EGP = 35,
  PLN = 36,
  LKR = 37,
  IQD = 38,
  BHD = 39,
  OMR = 40,
  JOD = 41,
  QAR = 42,
  MVR = 43,
  NPR = 44,
  PGK = 45,
  ILS = 46,
  HUF = 47,
  PKR = 48,
}

export enum ProductVatType {
  None = 1,
  ZeroPercent = 2,
  SevenPercent = 3,
}

export enum DiscountType {
  Amount = 0,
  Percent = 1,
}

export enum WhtAmountType {
  NotSpecify = -2,
  None = -1,
  Custom = 0,
  ZeroPointSevenFive = 1,
  OnePercent = 2,
  TwoPercent = 3,
  ThreePercent = 4,
  FivePercent = 5,
  TenPercent = 7,
  FifteenPercent = 8,
  OnePointFivePercent = 9,
}

export enum TypeComponentNoti {
  Success = 1,
  Warn = 2,
  Error = 3,
  Upload = 4,
  Download = 5,
}

export enum HttpStatusCode {
  Continue = 100,
  SwitchingProtocols = 101,
  Processing = 102,
  EarlyHints = 103,
  OK = 200,
  Created = 201,
  Accepted = 202,
  NonAuthoritativeInformation = 203,
  NoContent = 204,
  ResetContent = 205,
  PartialContent = 206,
  MultiStatus = 207,
  AlreadyReported = 208,
  IMUsed = 226,
  Ambiguous = 300,
  MultipleChoices = 300,
  Moved = 301,
  MovedPermanently = 301,
  Found = 302,
  Redirect = 302,
  RedirectMethod = 303,
  SeeOther = 303,
  NotModified = 304,
  UseProxy = 305,
  Unused = 306,
  RedirectKeepVerb = 307,
  TemporaryRedirect = 307,
  PermanentRedirect = 308,
  BadRequest = 400,
  Unauthorized = 401,
  PaymentRequired = 402,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  NotAcceptable = 406,
  ProxyAuthenticationRequired = 407,
  RequestTimeout = 408,
  Conflict = 409,
  Gone = 410,
  LengthRequired = 411,
  PreconditionFailed = 412,
  RequestEntityTooLarge = 413,
  RequestUriTooLong = 414,
  UnsupportedMediaType = 415,
  RequestedRangeNotSatisfiable = 416,
  ExpectationFailed = 417,
  MisdirectedRequest = 421,
  UnprocessableEntity = 422,
  Locked = 423,
  FailedDependency = 424,
  UpgradeRequired = 426,
  PreconditionRequired = 428,
  TooManyRequests = 429,
  RequestHeaderFieldsTooLarge = 431,
  UnavailableForLegalReasons = 451,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
  HttpVersionNotSupported = 505,
  VariantAlsoNegotiates = 506,
  InsufficientStorage = 507,
  LoopDetected = 508,
  NotExtended = 510,
  NetworkAuthenticationRequired = 511,
}

export enum PaymentElementType {
  None = 0,
  List = 1,
  Payment = 2,
}

export enum BankAccountType {
  Cash = 0,
  Bank = 1,
  ExpenseClaim = 2,
  WithheldTax = 3,
  WithholdingTax = 4,
  EWallet = 5,
}

export enum ItemsDocumentType {
  None,
  ItemProduct,
  ItemBilling,
  ItemAssets,
  ItemAssetGroup,
}

export enum BankReferenceBankType {
  OTHER = 0,
  BBL = 1,
  KBANK = 2,
  SCB = 3,
  SME = 4,
  KTB = 5,
  BAY = 6,
  KK = 7,
  CIMB = 8,
  TMB = 9,
  TISCO = 10,
  TCR = 11,
  TCAP = 12,
  BAAC = 13,
  EXIM = 14,
  UOB = 15,
  LHBANK = 16,
  SCBT = 17,
  GSB = 18,
  IBANK = 20,
  ICBC = 21,
  JPMORGAN = 22,
  CITIBANK = 23,
  SMBC = 24,
  DB = 25,
  BNP = 26,
  MIZUHO = 27,
  THAIPR = 28,
  BOC = 29,
  BOA = 30,
  RBS = 31, //
  RHB = 32,
  IOB = 33,
  HSBC = 34,
  ANZ = 35,
  OCBC = 36,
  GHBANK = 37,
}

export enum BankType {
  None = 0,
  CurrentAccount = 1,
  SavingAccount = 2,
  FixedDeposit = 3,
}

export enum EWalletProviderType {
  None = 0,
  Wallet2C2P = 1,
  WalletOmise = 2,
  TrueWallet = 3,
  LinePayWepay = 4,
  Paypal = 5,
  PaySolutions = 6,
  GbPrimePay = 7,
  WalletLazada = 8,
  WalletShopee = 9,
  WalletJD = 10,
  Grab = 11,
  FoodPanda = 12,
  LineMan = 13,
  Lalamove = 14,
  Robinhood = 15,
  BigThailand = 16,
  Stripe = 17,
  Payoneer = 18,
  BeamWallet = 19,
  TikTokShop = 20,
  mPay = 21,
  HDmall = 22,
  WalletAtPost = 23,
}

export enum ExpenseType {
  None = 0,
  Expense = 1,
  PurchaseInventory = 2,
  PurchaseAsset = 3,
}

export enum QuotationHeaderType {
  MainQuotationHeader = 0,
  CustomizeHeader = 1,
  TemporaryDeliveryNoteHeader = 2,
}

export enum InvoiceHeaderType {
  MainInvoiceHeader = 0,
  CustomizeHeader = 1,
  DeliveryNoteHeader = 2,
  BillingNoteHeader = 3,
  BillOfGoodsHeader = 4,
}

export enum ReceiptHeaderType {
  MainReceiptHeader = 0,
  CustomizeHeader = 1,
  ReceiveNoteHeader = 2,
  CashReceiptHeader = 3,
  AbbA4Header = 4,
  AbbPos58Header = 5,
  AbbPos80Header = 6,
}

export enum TaxInvoiceHeaderType {
  MainTaxInvoiceHeader = 0,
  CustomizeHeader = 1,
}
export enum CreditNoteHeaderType {
  MainCreditNoteHeader = 0,
  CustomizeHeader = 1,
}
export enum CreditNoteExpenseHeaderType {
  MainCreditNoteExpenseHeader = 0,
  CustomizeHeader = 1,
  PaymentNoteHeader = 2,
}
export enum DebitNoteHeaderType {
  MainDebitNoteHeader = 0,
  CustomizeHeader = 1,
}
export enum DebitNoteExpenseHeaderType {
  MainDebitNoteExpenseHeader = 0,
  CustomizeHeader = 1,
}

export enum PurchaseOrderHeaderType {
  MainPurchaseOrderHeader = 0,
  CustomizeHeader = 1,
  PurchaseRequisitionHeader = 2,
  PaymentRequisitionHeader = 3,
}

export enum ExpenseHeaderType {
  MainExpenseHeader = 0,
  CustomizeHeader = 1,
  PaymentNoteHeader = 2,
  ClaimNoteHeader = 3,
  BillOfLadingHeader = 4,
}

export enum BillingNoteHeaderType {
  MainBillingNoteHeader = 0,
  CustomizeHeader = 1,
}

export enum CombinePaymentNoteHeaderType {
  MainCombinePaymentNoteNoteHeader = 0,
  CustomizeHeader = 1,
  PaymentNoteHeader = 2,
}

export enum JournalHeaderType {
  MainJournalHeader = 0,
  CustomizeHeader = 1,
}

export enum ExecutiveSummaryHeaderType {
  MainExecutiveSummaryHeader = 0,
  CustomizeHeader = 1,
}

export enum DocumentUpdatePassCodeType {
  None = 0,
  Create = 1,
  Update = 2,
  CopyLink = 3,
  PrintPdf = 4,
}

export enum VerificationStatus {
  None = 0,
  Proccessing = 1,
  Success = 2,
}

export enum PeakExceptionResponseCode {
  None = 0,
  TransactionNumberDuplicated = 1,
  ContactNotFound = 2,
  ProductNotFound = 3,
  AccountNotFound = 4,
  LockByPeriod = 5,
  FreePackageOverCreateTransaction = 6,
  ProPlusImportTransaction = 7,
  FullPaymentAmount = 8,
  InputFieldEmptry = 9,
  TransactionIsVoided = 10,
  OverPaid = 11,
  ProductNameAndDescriptionIsDuplicated = 12,
  ProductTemplateCodeIsDuplicated = 13,
  AccountCodeIsDuplicated = 14,
  UnitCodeIsDuplicated = 15,
  BankAccountCodeIsDuplicated = 16,
  ContactCodeIsDuplicated = 17,
  TaxIdIsDuplicated = 18,
  ContactNameIsDuplicated = 19,
  IssuedTaxInvoiceDuplicated = 20,
  CanNotVoidInvoiceIsIssuedCreditNote = 25,
  CanNotVoidReceiptIsIssuedCreditNote = 26,
  LockByIssuedPP30 = 29,
  ReceivedTaxInvoiceNumberDuplicated = 41,
  ImportTransactionExceed = 43,
  IsHaveUserInSystem = 44,
  DuplicatedReferFriends = 45,
  DuplicateFileName = 46,
  CanNotVoidInvoiceIsIssuedDebitNote = 47,
  CanNotVoidReceiptIsIssuedDebitNote = 48,
  BankAccountNotFound = 49,
  OverInvitationUser = 50,
  UserAlreadyMerchant = 51,
  MerchantPackageIsNotAddUser = 52,
  CanNotEditSuperUser = 53,
  UserUpdateEqualEditUser = 54,
  CanNotRemoveSuperUser = 55,
  CanNotRemoveUser = 56,
  DuplicatedSettingNumberIndextString = 57,
  AuthorityRoleNotPermission = 58,
  NotHavePermissionUser = 59,
  NotHavePermissionFinance = 60,
  NotHavePermissionPayroll = 61,
  NotHavePermissionPeakBoard = 62,
  ApiPartnerNotFound = 63,
  MerchantIsNotAllowDuplicateContact = 64,
  CanNotDeleteThisFinance = 65,
  CanNotVoidAllocation = 66,
  CanNotVoidAllocationItem = 67,
  CreditLimitCannontCreate = 73,
  CreditLimitWarning = 74,
  InvalidDocumentPassCode = 76,
  CanNotEditInvoiceIsIssuedDebitNote = 77,
  CanNotEditInvoiceIsIssuedCreditNote = 78,
}

export enum JournalType {
  None = 0,
  PurchaseJournal = 1,
  SalesJournal = 2,
  PaymentJournal = 3,
  ReceiveJournal = 4,
  GeneralJournal = 5,
}

export enum PaymentInOutFlowType {
  None = 0,
  CashIn = 1,
  CashOut = 2,
}

export enum PndType {
  None = 0,
  PND1 = 1,
  PND2Specialkor = 2,
  PND2 = 3,
  PND3 = 4,
  PND2kor = 5,
  PND3kor = 6,
  PND53 = 7,
  PND54 = 8,
}

export enum TaxIncomeType {
  None = 0,
  SalariesIncome = 1,
  SalariesIncomeHaveWithholdingTaxRate = 2,
  SeverancePay = 3,
  SalariesWorkingIncome = 4,
  GoodwillAndRightIncome = 5,
  InterestOrDiscountIncome = 6,
  ProfitSharingIncome = 7,
  BonusToShareholder = 8,
  PortionOfDecapitalized = 9,
  IncreasedCapital = 10,
  BenefitFromConsolidated = 11,
  BenefitFromTrade = 12,
  AssetRentalIncome = 13,
  ProfessionalServiceIncome = 14,
  ContractWorkIncome = 15,
  HireOfWorkIncome = 16,
  AdvertisingIncome = 17,
  PrizeOrRewardIncome = 18,
  OtherServicesExcludeHotelRestaurantAndInsurance = 19,
  DiscountOrTradePromotion = 20,
  Insurance = 21,
  NonPublicTransport = 22,
  CelebrityHiring = 23,
}

export enum WitholdingTaxDocumentDisplayType {
  ShowOnlyOneAndTwo = 1,
  ShowOnlyOneTwoAndThreeFour = 2,
  ShowPageBreak = 3,
  ShowOneToFour = 4,
}

export enum WHTCertItemType {
  WHTCertItem401 = 1,
  WHTCertItem402 = 2,
  WHTCertItem403 = 3,
  WHTCertItem404A = 4,
  WHTCertItem40X1 = 5,
  WHTCertItem40X2 = 6,
  WHTCertItem40X3 = 7,
  WHTCertItemOther = 8,
  WHTCertItemOther2 = 9,
  WHTCertItem40X4 = 10,
}

export enum TaxSourceType {
  PeakTax = 0,
  PeakAccount = 1,
  PeakPayRoll = 2,
}

export enum PP30HeaderType {
  MainPP30Header = 0,
  CustomizeHeader = 1,
}

export enum PP30FormStatus {
  Draft = -2,
  AwaitApproval = -1,
  AwaitFiling = 0,
  Filed = 1,
}

export enum FiledType {
  None = 0,
  Document = 1,
  TextFile = 2,
  Api = 3,
}

export enum PP30FilingRoundType {
  None = 0,
  WithInDue = 1,
  OverDue = 2,
}
export enum PP30TaxCreditType {
  None = 0,
  RefundTax = 1,
  CreditTax = 2,
  ExpenseTax = 3,
}
export enum PP30TaxRefundType {
  None = 0,
  Cash = 1,
  Bank = 2,
}

export enum FilingType {
  None = 0,
  Normal = 1,
  More = 2,
}

export enum PndStatus {
  Draft = -2,
  AwaitApproval = -1,
  AwaitFiling = 0,
  Filed = 1,
}

export enum FilingCaseType {
  None = 0,
  M3Sec3 = 1, //ม.3 เตรส
  M65Sec4 = 2, //ม.65 จัตวา
  M69Sec2 = 3, //ม.69 ทวิ
  M48Sec2 = 4, //M.48 ทวิ
  M50 = 5, //ม. 50(3)(4)(5)
}

export enum ConditionType {
  None = 0,
  WithholdingTax = 1,
  LeaveForever = 2,
  LeaveOneTime = 3,
}

export enum WhtRateType {
  None = 0,
  Custom = 1,
  ZeroPointSevenFive = 2,
  OnePercent = 3,
  TwoPercent = 4,
  ThreePercent = 5,
  FivePercent = 6,
  TenPercent = 7,
  FifteenPercent = 8,
  OnePointFivePercent = 9,
}

export enum SettingVatFormType {
  None = 0,
  IncludedPreVat = 1,
  SeparatePreVat = 2,
}

export enum SortingType {
  DESC = 0,
  ASC = 1,
}

export enum PositionSummarizeDefault {
  None = 0,
  SummaryAmount = 1,
  paymentAmount = 2,
}

export enum EnvelopeHeaderType {
  MainEnvelopeHeader = 0,
}

export enum ContactEnvelopePageSizeType {
  None = 0,
  A5 = 1,
  A4 = 2,
  Envelope = 3,
  Standard = 4,
  Postcard = 5,
}

export enum WithholdingTaxPageSizeType {
  None = 0,
  A5 = 1,
  A4 = 2,
}

export enum SettingCertifiedDate {
  None = 0,
  ByDefaultDate = 1,
  ByIssuedDate = 2,
}

export enum AmountInfoSettingType {
  None = 0,
  ShowAmountCaseZero = 1,
  NotDisplayCaseZero = 2,
}

export enum SettingAreaPunchingType {
  None = 0,
  LeftCorner = 1,
  LeftEdge = 2,
}

export enum PrefixNameType {
  None = 0,
  Khun = 1,
  Mr = 2,
  Mrs = 3,
  Ms = 4,
  Other = 5,
}

export enum DepartmentType {
  None = 0,
  GeneralManagement = 1,
  GeneralAdministration = 2,
  Sales = 3,
  Marketing = 4,
  Accounting = 5,
  Finance = 6,
  HumanResource = 7,
  Production = 8,
  Operation = 9,
  InformationTechnology = 10,
  Purchasing = 11,
  ResearchAndDevelopment = 12,
  Other = 13,
}

export enum OptionType {
  None = 0,
  ETaxInvoice = 1,
  IsDeleted = 2,
}

export enum SettingWhtItem40XShowingType {
  None = 0,
  CombinedShowing = 1,
  SeparatedShowing = 2,
}

export enum DocumentFontType {
  Sukhumvit = 1,
  THSarabunNew = 2,
}

export enum DocumentFormat {
  FormatOne = 1,
  FormatTwo = 2,
}

export enum DocumentSize {
  A4 = "a4",
  A5 = "a5",
}

export enum DocumentOrientation {
  Portrait = "p",
  Landscape = "l",
}

export enum Package {
  Trial = 0,
  Free = 1,
  Basic = 2,
  Pro = 3,
  ProPlus = 4,
}

export enum Role {
  None = 0,
  ViewOnly = 1, // ดูได้อย่างเดียว
  PartialRightsDraftOnly = 2, //สิทธิบางส่วน ร่างได้อย่างเดียว
  PartialRightsApproveAndReceivePayment = 3, //สิทธิบางส่วน อนุมัติและรับจ่าย
  PartialRightsRevenueOnly = 4, //สิทธิบางส่วน ฝั่งรายได้อย่างเดียว
  PartialRightsExpenseOnly = 5, //สิทธิบางส่วน ฝั่งรายจ่ายอย่างเดียว
  PartialRightsQuotationOnly = 6, //สิทธิบางส่วน ใบเสนอราคาอย่างเดียว
  StandardRightsViewReport = 7,
  StandardRightsNotViewReport = 8,
  Admin = 9,
}

export enum QRPaymentType {
  None = 0,
  Bank = 1,
  SCB = 2,
  PaySolutions = 3,
  Bay = 4,
  Bbl = 5,
  Beam = 6
}

export enum ExecutiveSummaryStatus {
  None = 0,
  Draft = 1,
  Approved = 2,
}

export enum ExecutiveSummaryPeriodType {
  None = 0,
  Month = 1,
  Quarter = 2,
  Year = 3,
}

export enum ExecutiveSummaryTransactionItemType {
  None = 0,
  OperationIncome = 1,
  CostsOfSales = 2,
  GrossProfit = 3,
  Expenses = 4,
  CostOfFinancing = 5,
  TaxRevenues = 6,
  NetProfit = 7,
  CashReceived = 8,
  CashSpent = 9,
  GainsInForeignExchange = 10,
  NetCashReceived = 11,
  CashBalance = 12,
  AccountsReceivable = 13,
  Inventory = 14,
  AccountsPayable = 15,
  QuickRatio = 16,
  InventoryTurnOver = 17,
  ReceivablesTurnOver = 18,
  AccountPayableTurnOverRatio = 19,
  AveragePaymentPeriod = 20,
  AverageInventoryPeriod = 21,
  AverageCollectionPeriod = 22,
  CashConversionCycle = 23,
  QuotationNumberIssued = 24,
  QuotationNetAmountIssued = 25,
  QuotationAverageIssued = 26,
  InvoiceNumberIssued = 28,
  InvoiceNetAmountIssued = 29,
  InvoiceAverageIssued = 30,
  GrossProfitRatio = 31,
  NetProfitMargin = 32,
  TotalAssetTurnOver = 33,
  TotalEquityTurnOver = 34,
  EquityMultiplier = 35,
  ROA = 36,
  ROE = 37,
}

export enum ExecutiveSummaryTransactionGroupType {
  businessPerformance = 1,
  cash = 2,
  workingCapital = 3,
  quatationAndInvoice = 4,
  financialRatio = 5,
}

export enum AlignmentDocumentControlNo {
  None = 0,
  LeftFooter = 1,
  CenterFooter = 2,
  RightFooter = 3,
}

export enum DocumentHeaderSize {
  None = 0,
  Small = 1,
  Medium = 2,
  Large = 3,
}

export enum AddressInfoType {
  RegisteredAddressTh = 0,
  RegisteredAddressEn = 1,
  MailingAddress = 2,
  Additional = 3,
}
export enum DocumentTourStatus {
  Hide = 0,
  Show = 1,
  Edit = 2,
}

export enum InvoiceDatabaseStatus {
  Draft = -2,
  AwaitApproval = -1,
  OutstandingOrOverdue = 0,
  PaidOrAwaitReceipt = 1,
  GotReceipt = 2
}

export enum BillingNoteDatabaseStatus
{
  Draft = -2,
  AwaitApproval = -1,
  OutstandingOrOverdue = 0,
  PaidOrAwaitReceipt = 1 
}

export enum DebitNoteDatabaseStatus
{
  Draft = -2,
  AwaitApprove = -1,
  Approved = 0,
  Paid = 1  
}